<ng-container *ngIf="chart">
    <h3 class="mt-4 mb-2">{{ title }}<app-platform-health-help-icon [text]="helpText"></app-platform-health-help-icon></h3>
    <p-chart type="line" [data]="chart" [options]="options" height="180px"></p-chart>
</ng-container>

<!-- el título existe (el inquilino tiene el dato que titula), pero no hay gráfica que pintar: se
     explica en vez de dejar el hueco, que en un panel de diagnóstico se leería como "todo tranquilo" -->
<p-messages severity="warn" *ngIf="!chart && emptyMessage">
    <ng-template pTemplate>
        <div class="ml-2">{{ emptyMessage }}</div>
    </ng-template>
</p-messages>
